import React from "react";

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
        style={{ backgroundColor: "var(--c-active)" }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          style={{ color: "var(--c-text-faint)" }}
        >
          <circle cx="10" cy="10" r="8" />
          <path d="M10 6v4M10 14h.01" />
        </svg>
      </div>
      <h3 className="text-sm font-medium mb-1" style={{ color: "var(--c-text-secondary)" }}>
        {title}
      </h3>
      {description && (
        <p className="text-xs max-w-sm" style={{ color: "var(--c-text-faint)" }}>
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
